<template>
  <v-container>
    <v-app-bar app color="primary">
      <v-btn @click="tornaAllaHome">Esci</v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="schedaPrecendente">Indietro<v-icon></v-icon></v-btn>
      <v-btn @click="schedaSuccesiva">Avanti</v-btn>
    </v-app-bar>
    <v-flex d-flex xs12 sm12 md12 lg12 xl12 justify-center>
      <h2>VERBALE DI VERIFICA PERIODICA</h2>
    </v-flex>
    <v-flex d-flex xs12 sm12 md12 lg12 xl12 justify-center>
      <h6>(DLgs 81/2088 art...)</h6>
    </v-flex>
    <v-flex d-flex xs12 sm12 md12 lg12 xl12>
      <h4>Verbale n° ...SP</h4>
    </v-flex>

    <v-flex xs12 sm12 md12 lg12 xl12>
      <v-stepper v-model="numeroScheda" vertical non-linear>
        <!--Prima scheda - Titolo scheda-->
        <v-stepper-step editable :complete="numeroScheda > 1" step="1">Scheda</v-stepper-step>
        <v-stepper-content step="1">
          
        </v-stepper-content>
        <!--Fine prima scheda-->
      </v-stepper>
    </v-flex>

  </v-container>
</template>

<script>
/*eslint-disable  */
import DataPicker from '../components/DataPicker'
import ConfirmDialog from '../components/ConfirmDialog'

export default {
  components:{
    DataPicker,
    ConfirmDialog
  },
  data() {
    return {
      numeroScheda: 1,
      schedeTotali:1
    };
  },
  methods: {
    schedaPrecendente(){
      if(this.numeroScheda>1){
        this.numeroScheda-=1
      }
    },
    schedaSuccesiva(){
      if(this.numeroScheda<this.schedeTotali){
        this.numeroScheda+=1
      }else{
        this.salvaReport()
      }
    },
    tornaAllaHome(){
      this.$router.push({path:"/"})
    },
    salvaReport(){

    }
  },
  created() {
    this.$vuetify.lang.current = "it";
  }
};
</script>
<style>
.space-up {
  padding-top: 5px;
}
</style>